import { ProgramTimings } from "./program-timings";
import { ProgramGradesServed } from "./program-grades-served";
import { ProgramProgramsOffered } from "./program-programs-offered";
import { ProgramMealsServed } from "./program-meals-served";
export class ProgramServices {
    public id: number;
    public timing: ProgramTimings;
    public gradesServed: ProgramGradesServed;
    public programsOffered: ProgramProgramsOffered;
    public mealsServed: ProgramMealsServed;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/program/program-services.ts